<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="outrasDatasAtendModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="iniciado">
                    <div class="modal-header">
                        <h5 class="modal-title">Outras Datas</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <repetir-agenda
                            :id_medico="id_medico"
                            :coluna_unica="true"
                            v-model="dados.repeticao" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="livres()">Editar</button>
                        <button type="button" class="btn btn-success" @click="lancar()">Lançar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import RepetirAgenda from '../callcenter/RepetirAgenda.vue';

export default {
    data() {
        return { 
            dados: { 
                repeticao: { 
                    base: null, 
                    hora: null
                }
            }, 

            iniciado: false, 
        }
    },

    props: ['id_medico', 'pode_vazio', 'pode_livre'],

    components: { 
        RepetirAgenda, 
    }, 

    methods: {
        livres () { 
            this.fechar_modal();
            this.$emit('livres');
        },

        lancar() { 

            if ( !this.pode_vazio && ( !this.dados || !this.dados.repeticao || !this.dados.repeticao.valid ) ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: 'Selecione as datas para o lançamento.', 
                    life: 3000
                });
                return;
            }

            let datas = [];

            _.each(
                this.dados.repeticao.valid, 
                (status, data) => { 
                    if ( status == 'S' ) { 
                        datas.push(data);
                    }
                }
            );

            if ( datas && ( datas.length > 1 || this.pode_vazio ) ) { 
                this.$emit('lancar', datas);
                this.fechar_modal();
            } else { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção222', 
                    detail: 'Selecione as datas para o lançamento.', 
                    life: 3000
                });
            }

        },

        abrir(data, hora) {
            this.iniciado = true; 

            this.dados.repeticao = {
                base: data,
                hora: hora
            };

            $('#outrasDatasAtendModal').modal('show');
        },

        fechar_modal() {
            $('#outrasDatasAtendModal').modal('hide');
            this.iniciado = false;
        }
    }
}
</script>
